import { makeAutoObservable } from "mobx";
import { safe_get } from "../report-visuals";

export type voterFiltersType = {
  projectid: number;
  booths: string[];
  genders: string[];
  age: number[];
  serialno: string;
  name: string;
  relation: string;
  voterid: string;
  page: string;
  df: {};
  house: string;
  offset: number;
  count: number;
  dob: any;
};

export class VoterListStore {
  rootStore: any;
  isFilterDataUpdated = false;
  isSideOverlay = false;
  voterListStore: any[] = [];
  FilterStatus = false;
  showVoterlist = false;
  selectedVoterData: any = null;
  FilterVal: any = null;
  SearchBooth: any[] = [];
  Voterlist: any[] = [];
  activeVoter: any = {};
  activeScheme: any = "";
  family_members: {}[] = [];
  connect_user_to_voterlist_modal = false;
  currentTabValue: string = "";
  edit_voter_modal = false;
  scheme_info = false;
  voter_eligible_schemes = false;
  scheme_eligibilty_criteria = false;
  voterEligibleSchemeList: any[] = [];
  voterSchemeProfile: any[] = [];

  voter_filters: voterFiltersType;

  prevDeps: any = {};

  constructor(rootStore: any) {
    this.rootStore = rootStore;
    this.voter_filters = {
      projectid: safe_get(this.rootStore?.projectStore, "activeProject.id", -1),
      booths: [],
      genders: ["Male", "Female", "Third Gender"],
      age: [18, 120],
      serialno: "",
      name: "",
      relation: "",
      voterid: "",
      page: "",
      df: {},
      house: "",
      offset: 0,
      count: 100,
      dob: "",
    };

    makeAutoObservable(this);
  }
  setCurrentTabValue = (value: string) => {
    this.currentTabValue = value;
  };
  update_voter_eligible_scheme_list = (data: any[]) => {
    this.voterEligibleSchemeList = data;
  };

  update_voter_scheme_profile = (data: any[]) => {
    this.voterSchemeProfile = data;
  };

  update_filters(params: voterFiltersType) {
    this.voter_filters = { ...params };
  }

  reset_filters(projectid: number) {
    this.voter_filters = {
      projectid,
      booths: [],
      genders: ["Male", "Female", "Third Gender"],
      age: [18, 120],
      serialno: "",
      name: "",
      relation: "",
      voterid: "",
      page: "",
      df: {},
      house: "",
      offset: 0,
      count: 100,
      dob: "",
    };
  }

  setFilterVal(val: any) {
    this.FilterVal = val;
  }

  setShowVoterlist(status: boolean) {
    this.showVoterlist = status;
  }

  setSelectedBooths(val: any[]) {
    this.SearchBooth = val;
  }

  setVoterList(val: any[]) {
    this.Voterlist = val;
  }

  setSelectedVoterData(data: any) {
    this.selectedVoterData = data;
  }

  setFilterStatus(status: boolean) {
    this.FilterStatus = status;
  }

  setRenderInOverlay(status: boolean) {
    this.isSideOverlay = status;
  }

  update_active_voter(voter: any) {
    this.activeVoter = voter;
    this.family_members = voter["family"]?.length > 0 ? voter["family"] : [];
  }

  update_active_scheme(schemeID: any) {
    this.activeScheme = schemeID;
  }

  update_connect_user_to_voterlist_modal(status: boolean) {
    this.connect_user_to_voterlist_modal = status;
  }

  update_family_members(data: any[]) {
    this.family_members = data;
  }

  async getVoterSearch() {
    const response = await this.rootStore.api.post(
      "voters/search",
      this.voter_filters
    );
    this.Voterlist = response?.data?.results;
    return response;
  }

  async getVoterFamily(payload: any) {
    return await this.rootStore.api.post("voters/voterdetails", payload);
  }

  async getVoterServiceRequest(payload: any) {
    return await this.rootStore.api.post(
      "voters/voter_service_request",
      payload
    );
  }

  async getScannedVoter(payload: any) {
    return await this.rootStore.api.post("ai/facereco", payload);
  }

  async attach_VoterProfile(payload: any) {
    return await this.rootStore.api.post(
      "/user/userattachvoterprofile",
      payload
    );
  }

  update_edit_voter_modal(val: boolean) {
    this.edit_voter_modal = val;
  }

  update_info_scheme(val: boolean) {
    this.scheme_info = val;
  }

  update_voter_eligible_schemes(val: boolean) {
    this.voter_eligible_schemes = val;
  }

  update_scheme_eligibilty_criteria(val: boolean) {
    this.scheme_eligibilty_criteria = val;
  }

  async update_voter_data(data: any) {
    return await this.rootStore.api.post("survey/voterrecordsessync", [data]);
  }
}
